import { useTranslation } from "react-i18next";
import { useLocation, Outlet } from "react-router-dom";
import { useEffect } from "react";

/**
 * Language codes that the app has translations for.
 * `ua` is accepted as an alias for `uk` (Ukrainian) because some external
 * links may use the ISO 3166-1 country code instead of the ISO 639-1 language code.
 */
const supportedLanguages = ['en', 'ru', 'uk', 'ua'];

/**
 * Layout that reads the first URL path segment and switches the i18n language
 * if it matches a supported language code.
 *
 * This layout sits at the `/:lang?` route level so every page and widget
 * automatically inherits language switching just from the URL — no explicit
 * language prop needs to be passed to any child component.
 *
 * If the first segment is not a known language code (e.g. it is "tolerance" or
 * "widgets"), i18n.changeLanguage() is called with no argument, which resets
 * to the configured fallback language ("en").
 */
function LangLayout() {
    const { i18n } = useTranslation();
    const location = useLocation();

    useEffect(() => {
        const pathSegments = location.pathname.split('/');
        const language = pathSegments[1];
    
        if (supportedLanguages.includes(language)) {
          i18n.changeLanguage(language);
        } else {
          i18n.changeLanguage();
        }
    }, [location, i18n]);

    return <Outlet />
}

export default LangLayout;
